import { gtcDebounce } from "./gtc-utils.js";

const productCardImageSelector = ".ProductItem__ImageWrapper";

/************************* *Content block  *************************/
class CollectionContentBlock extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.dom = {
      container: this.querySelector(".gtc-collection-content-block__media-container"),
    };

    if (this.hasAttribute("reveal")) {
      this.showOnIntersection();
    }

    if (this.hasAttribute("match-product-image-height")) {
      this.init();
    }
  }

  init() {
    const productImage = this.parentElement.querySelector(
      productCardImageSelector
    );
    if (!productImage) {
      return;
    }

    const setContainerHeight = () => {
      this.style.setProperty('--match-product-image-height', productImage.getBoundingClientRect().height + "px");
    }


    const handleResize = gtcDebounce(() => {
      setContainerHeight();
    }, 10);

    window.addEventListener("resize", handleResize);

    setContainerHeight();

  }

  showOnIntersection() {
    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.1,
    };

    const callback = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          requestAnimationFrame(() => {
            this.removeAttribute("reveal");
          });

          intersectionObserver.unobserve(this);
        }
      });
    };

    const intersectionObserver = new IntersectionObserver(callback, options);
    intersectionObserver.observe(this);
  }
}

if (!customElements.get("gtc-collection-content-block")) {
  customElements.define("gtc-collection-content-block", CollectionContentBlock);
}
